exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.build-list-screen .v-icon {\n  margin: 0 5px;\n}\n.build-list-screen .transparent {\n  opacity: 0.5;\n}\n", ""]);

// exports
